import { render, staticRenderFns } from "./AddressChange.vue?vue&type=template&id=76ed9620"
import script from "./AddressChange.vue?vue&type=script&lang=ts"
export * from "./AddressChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports